import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f474f458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-control" }
const _hoisted_2 = { class: "pc-row" }
const _hoisted_3 = { class: "pc-field-wrap" }
const _hoisted_4 = { class: "pc-field" }
const _hoisted_5 = {
  key: 0,
  class: "pc-error"
}
const _hoisted_6 = { class: "pc-field-wrap" }
const _hoisted_7 = { class: "pc-field" }
const _hoisted_8 = {
  key: 0,
  class: "pc-error"
}
const _hoisted_9 = { class: "pc-field-wrap" }
const _hoisted_10 = { class: "pc-field" }
const _hoisted_11 = {
  key: 0,
  class: "pc-error"
}
const _hoisted_12 = { class: "pc-field-wrap" }
const _hoisted_13 = { class: "pc-field" }
const _hoisted_14 = {
  key: 0,
  class: "pc-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            style: _normalizeStyle({ color: _ctx.colors.textSecondary })
          }, "初始资金", 4),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.initCapital) = $event)),
            class: _normalizeClass(["pc-input", { 'pc-input-error': _ctx.capitalError }]),
            style: _normalizeStyle(_ctx.inputStyle),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateCapital && _ctx.validateCapital(...args)))
          }, null, 38), [
            [_vModelText, _ctx.initCapital]
          ]),
          _createElementVNode("span", {
            style: _normalizeStyle({ color: _ctx.colors.textMuted })
          }, "万", 4)
        ]),
        (_ctx.capitalError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.capitalError), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", {
            style: _normalizeStyle({ color: _ctx.colors.textSecondary })
          }, "个股最大持仓", 4),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maxSinglePos) = $event)),
            class: _normalizeClass(["pc-input", { 'pc-input-error': _ctx.singlePosError }]),
            style: _normalizeStyle(_ctx.inputStyle),
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateInt('maxSinglePos')))
          }, null, 38), [
            [_vModelText, _ctx.maxSinglePos]
          ]),
          _createElementVNode("span", {
            style: _normalizeStyle({ color: _ctx.colors.textMuted })
          }, "%", 4)
        ]),
        (_ctx.singlePosError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.singlePosError), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", {
            style: _normalizeStyle({ color: _ctx.colors.textSecondary })
          }, "账户最大持股数", 4),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.maxHoldCount) = $event)),
            class: _normalizeClass(["pc-input", { 'pc-input-error': _ctx.holdCountError }]),
            style: _normalizeStyle(_ctx.inputStyle),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateInt('maxHoldCount')))
          }, null, 38), [
            [_vModelText, _ctx.maxHoldCount]
          ]),
          _createElementVNode("span", {
            style: _normalizeStyle({ color: _ctx.colors.textMuted })
          }, "只", 4)
        ]),
        (_ctx.holdCountError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.holdCountError), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", {
            style: _normalizeStyle({ color: _ctx.colors.textSecondary })
          }, "单日最大买入数", 4),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.maxDailyBuy) = $event)),
            class: _normalizeClass(["pc-input", { 'pc-input-error': _ctx.dailyBuyError }]),
            style: _normalizeStyle(_ctx.inputStyle),
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateInt('maxDailyBuy')))
          }, null, 38), [
            [_vModelText, _ctx.maxDailyBuy]
          ]),
          _createElementVNode("span", {
            style: _normalizeStyle({ color: _ctx.colors.textMuted })
          }, "只", 4)
        ]),
        (_ctx.dailyBuyError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.dailyBuyError), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}